import * as React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  Grid,
  InputAdornment,
  TextField,
  Typography
} from "@material-ui/core";
import PropTypes from "prop-types";
import { Formik } from "formik";
import { creditActivity } from "../../validations/credit";
import SearchDropdown from "../../components/common/SearchDropdown";
import useAccount from "../../hooks/useAccount";
import CustomDialogTitle from "../../components/common/CustomDialogTitle";

const voucherOutTypes = [
  { label: "Chi khác", id: 1, value: 1, key: 1 },
  { label: "Trả lương", id: 2, value: 2, key: 2 },
  { label: "Trả lãi", id: 3, value: 3, key: 3 },
  { label: "Chi tiêu dùng", id: 4, value: 4, key: 4 },
  { label: "Chi trả quỹ", id: 5, value: 5, key: 5 },
  { label: "Tạm ứng", id: 6, value: 6, key: 6 },
  { label: "Hoa hồng", id: 7, value: 7, key: 7 },
  { label: "Chi vé hoặc văn phòng", id: 7, value: 8, key: 8 },
  { label: "Chi mua xe", id: 9, value: 9, key: 9 },
  { label: "Chi Dọn xe - Hồ sơ", id: 10, value: 10, key: 10 },
  { label: "Chi Tiền Nhà", id: 11, value: 11, key: 11 },
  { label: "Chi mượn tiền", id: 12, value: 12, key: 12 }
];

const Add = ({ open, handleClose }) => {
  const { useCreateCashFlow } = useAccount();

  return (
    <div>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
        <CustomDialogTitle
          title="Nhập phiếu chi tiền"
          handleClose={handleClose}
        />
        <Formik
          initialValues={{
            partnerName: "",
            amount: "",
            voucherType: "",
            reason: "",
            type: "out"
          }}
          validationSchema={creditActivity()}
          onSubmit={async (values, actions) => {
            await useCreateCashFlow(values, actions);
            handleClose();
          }}
        >
          {({
            errors,
            handleChange,
            touched,
            isValid,
            isSubmitting,
            values,
            handleSubmit,
            handleBlur,
            setFieldValue
          }) => (
            <>
              <DialogContent>
                <Typography
                  color="textPrimary"
                  variant="h4"
                  sx={{ my: 1, textTransform: "uppercase" }}
                >
                  Nhập phiếu chi tiền
                </Typography>
                <Divider />
                <Grid container spacing={2}>
                  <Grid item sm={12} md={8}>
                    <TextField
                      error={Boolean(touched.partnerName && errors.partnerName)}
                      helperText={touched.partnerName && errors.partnerName}
                      onChange={handleChange}
                      autoFocus
                      size="small"
                      margin="normal"
                      id="partnerName"
                      value={values.partnerName}
                      label="Người chi tiền"
                      required
                      type="text"
                      fullWidth
                      variant="outlined"
                    />
                    <TextField
                      error={Boolean(touched.amount && errors.amount)}
                      helperText={touched.amount && errors.amount}
                      onChange={event => {
                        let newValue = event.target.value;
                        newValue =
                          parseInt(newValue.replace(/[^\d\\.]/g, "")) || "";
                        setFieldValue("amount", newValue);
                      }}
                      size="small"
                      margin="normal"
                      id="amount"
                      value={values.amount.toLocaleString("en-US") || 0}
                      label="Số tiền"
                      type="text"
                      fullWidth
                      variant="outlined"
                      required
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">VNĐ</InputAdornment>
                        )
                      }}
                    />
                    <SearchDropdown
                      title="Loại phiếu"
                      data={voucherOutTypes || []}
                      error={Boolean(touched.voucherType && errors.voucherType)}
                      helperText={touched.voucherType && errors.voucherType}
                      value={values.voucherType}
                      onBlur={handleBlur}
                      setFieldValue={setFieldValue}
                      required
                      id="voucherType"
                    />
                    <TextField
                      error={Boolean(touched.reason && errors.reason)}
                      helperText={touched.reason && errors.reason}
                      onChange={handleChange}
                      size="small"
                      margin="normal"
                      id="reason"
                      value={values.reason}
                      label="Lý do chi tiền"
                      type="text"
                      fullWidth
                      multiline
                      rows={5}
                      variant="outlined"
                    />
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions
                sx={{
                  borderTop: "1px solid rgba(224, 224, 224, 1)"
                }}
                className="justify-start"
              >
                <Grid container spacing={2}>
                  <Grid item sm={12} md={12}>
                    <Button
                      variant="contained"
                      disabled={!isValid || isSubmitting}
                      onClick={handleSubmit}
                      sx={{
                        marginRight: 2,
                        marginLeft: 2
                      }}
                      size="small"
                    >
                      Lưu lại
                    </Button>
                    <Button
                      variant="outlined"
                      onClick={handleClose}
                      size="small"
                    >
                      Đóng
                    </Button>
                  </Grid>
                </Grid>
              </DialogActions>
            </>
          )}
        </Formik>
      </Dialog>
    </div>
  );
};
Add.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func
};

export default Add;
